import { type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { useBasket } from './useBasket';
import type { RecaptchaPayload } from '../../recaptcha/recaptcha';
import type { Basket, CouponItem } from './model';

export interface CouponItemWithRecaptcha extends CouponItem {
    recaptcha?: RecaptchaPayload;
}

export const useAddCoupon = (): UseMutationResult<Basket, unknown, CouponItemWithRecaptcha> => {
    const { data } = useBasket();
    const queryClient = useQueryClient();

    return useBffPostMutation<Basket, CouponItemWithRecaptcha>(
        `/baskets/${data?.basketId}/coupons`,
        [],
        [],
        {
            basketCustomerId: data?.customerInfo?.customerId,
            onSuccess: (basket) => {
                queryClient.setQueryData([BffQueryKey.BASKET], basket);
            },
        },
    );
};
